import {
	EnhancedDropDownRHFWithLabel,
	ITest,
	LabelPosition,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";
import { useGetLookupFieldData } from "../../../EmployeeSetup/Panels/EmployeePayrollSetupFieldsPanel";

interface IFilingDataSetupFieldsPanel extends ITest {
	formMethods: any;
	payFrequencyDDLItems: any;
}

export const FilingDataSetupFieldsPanel: FC<IFilingDataSetupFieldsPanel> = ({
	testId,
	formMethods,
	payFrequencyDDLItems
}) => {
	// const { isLoading: isLoadingPayPeriods, data: payPeriodsList } =
	// 	useGetLookupFieldData("payPeriods");

	const onPayPeriodChangeHandler = (value: any) => {
		formMethods.setValue("pensionablePeriod", value.value);
	};
	return (
		<>
			<EnhancedDropDownRHFWithLabel
				label="Payroll Schedule"
				selectName="payFrequency"
				items={payFrequencyDDLItems ?? []}
				selectedItem={26}
				testId="pay-periods"
				labelPosition={LabelPosition.Top}
				onSelectionChangeHandler={onPayPeriodChangeHandler}
				required
			/>
			{/* <RHookFormTextFieldWithLabel
				label="Pensionable Periods"
				id="pensionablePeriod"
				testId="pensionable-periods"
				labelPosition={LabelPosition.Top}
				// value="26"
				defaultValue={26}
				required
			/> */}
			{/* <EnhancedDropDownRHFWithLabel
        label="Slip Type"
        selectName="slipType"
        items={[
          { label: "Original", value: 400 },
          { label: "Amended", value: 200 },
          { label: "Cancelled", value: 300 },
          { label: "Additional", value: 100 },
        ]}
        selectedItem={400}
        testId="slip-type"
        labelPosition={LabelPosition.Top}
        required
      /> */}
			<EnhancedDropDownRHFWithLabel
				label="Status"
				selectName="slipStatus"
				items={[
					{ label: "Draft", value: 200 },
					{ label: "Completed", value: 100 },
				]}
				selectedItem={200}
				testId="status"
				labelPosition={LabelPosition.Top}
				required
			/>
		</>
	);
};
